import React from 'react';
import '../less/index';
import Breadcrumbs from '../../../../auxiliary-components/Breadcrumbs';
import {
    MAIN,
    SPECIAL_OFFERS,
    ALWAYS_TOUCH
} from '../../../../auxiliary-components/Breadcrumbs/collection/breadcrumbs.config';
import {Link, Control} from 'MWC';
export const LANG = {
    UA: 'ua',
    RU: 'ru',
    UK: 'uk'
};



export default function template() {
    const links = [MAIN, SPECIAL_OFFERS, ALWAYS_TOUCH];

    return (
        <div className='module-always-touch'>
            <Breadcrumbs links={links} {...this.props} />
            <div className='banner'>
                <div className='banner-content'>
                    <div className='banner-title'>
                        <p className='banner-title_text'>{this.l10n('ALWAYS_TOCH_HEADING')}</p>
                    </div>
                    <div className='push-mobile'>
                        <p className='push-mobile_text'>{this.l10n('TOP_UP_MOBILE_TEXT')}</p>
                    </div>
                    <div className='promotion-block'>
                        <p className='promotion-block_text'>
                            {this.l10n('PROMOTION_FOR_CUSTOMERS_TEXT')}
                        </p>
                    </div>
                </div>
            </div>

            <div className='content'>
                <div className='conditions-block action'>
                    <p>{this.l10n('TERMS_OF_PARTICIPATION_TEXT')}</p>

                    <div className='conditions-action'>
                        <div className='conditions-action-one'>
                            <div className='number-one'>
                                <p className='number-one-text'>1</p>
                            </div>
                            <div className='block-one_text'>
                                <p
                                    className='block-one_text-conditions'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('INSTALLED_APPLICATION_A24_TEXT')
                                    }}
                                ></p>
                            </div>
                        </div>

                        <div className='conditions-action-two'>
                            <div className='number-two'>
                                <p className='number-two-text'>2</p>
                            </div>
                            <div className='block-two_text'>
                                <p
                                    className='block-two_text-conditions'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('TOP_UP_MOBILE_TEXT_1')
                                    }}
                                ></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='winner-block'>
                    <p className='select-winner-title-mobile'>
                        {this.l10n('CHOOSING_WINNER_TEXT')}
                    </p>
                    <div className='left-part'>
                        <div className='left-img'></div>
                    </div>

                    <div className='right-part'>
                        <div className='block-info'>
                            <p className='select-winner-title'>
                                {this.l10n('CHOOSING_WINNER_TEXT')}
                            </p>
                            <div className='select-winner-text1'>
                                {this.l10n('CHOOSING_WINNER_TEXT_1')}
                            </div>
                            <div className='select-winner-text2'>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('CHOOSING_WINNER_TEXT_2')
                                    }}
                                ></p>
                            </div>
                            <div className='select-winner-text3'>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('CHOOSING_WINNER_TEXT_3')
                                    }}
                                ></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='section files'>
                    <h2 className='section-title'>{this.l10n('CREDIT_FILES_TO_LOAD')}</h2>
                    <div className='files'>
                        <Control>
                            <div className='files-item'>
                                <Link

                                    href={
                                        this.props.lang === LANG.UA
                                            ? '/static/promotion-rules-ukr.pdf'
                                            : '/static/promotion-rules-ru.pdf'
                                    }

                                    target='_blank'
                                    inText={true}
                                >
                                    <span className='document-pdf' />
                                    <span className='document-label'>
                                        {this.l10n('RULES_PROMOTION_TEXT')}
                                    </span>
                                </Link>
                            </div>
                        </Control>
                    </div>
                </div>
            </div>
        </div>
    );
}
